import timeStampToDate from '@/helpers/timeStampToDate';
import { isHTMLString, removeHTMLTags } from '@/helpers/utils';
import type {
  ProcessCellForExportParams,
  ValueFormatterParams,
  ValueGetterParams
} from 'ag-grid-community';

type AgGridCellParams<TData extends object> = ProcessCellForExportParams<TData>;

const decodeValue = (value: unknown): string => {
  try {
    return decodeURIComponent(value as string);
  } catch (error) {
    return value as string;
  }
};

// CLipboard Process
export const processCellForClipboard = <TData extends object>(
  params: AgGridCellParams<TData>,
  loc: string
): string | undefined => {
  if (loc.includes('keyword-tracker')) {
    return trackerExportsModify(params);
  }
  if (loc.includes('page-speed/speed')) {
    return speedExportModify(params);
  } else {
    let res = '';
    const decodedValue = decodeValue(params.value);
    if (isHTMLString(decodedValue)) {
      res = removeHTMLTags(decodedValue);
    } else {
      res = decodedValue;
    }
    return res;
  }
};
export const decodeGetter = <TData extends object>(
  params: ValueGetterParams<TData, unknown>
): string => {
  if (params.data) {
    const data = params.data as Record<string, unknown>;
    const value = params.colDef.field
      ? data[params.colDef.field]
      : undefined;
    return value
      ? decodeValue(value)
      : '';
  }
  return '';
};
export const dateFilterGetter = <TData extends object>(
  params: ValueGetterParams<TData, unknown>
): string | undefined => {
  if (params.data) {
    try {
      const data = params.data as Record<string, unknown>;
      const value = params.colDef.field
        ? data[params.colDef.field]
        : undefined;
      return timeStampToDate(Number(value)).slice(8);
    } catch (error) {
      return '';
    }
  }
  return undefined;
};
export const valueFormatter = <TData extends object, TValue = unknown>(
  p: ValueFormatterParams<TData, TValue>
): string => {
  if (p?.value == null || p?.value === '') return '';

  if (Array.isArray(p.value)) {
    return p.value
      .map(item => {
        try {
          return decodeURIComponent(item as string);
        } catch {
          return String(item);
        }
      })
      .join(', ');
  }

  if (typeof p.value === 'object') return '';

  try {
    return decodeURIComponent(p.value as string);
  } catch (error) {
    console.log('Error in decode URI URLRenderer.');
    return String(p.value);
  }
};

const trackerExportsModify = <TData extends object>(
  params: AgGridCellParams<TData>
): string | undefined => {
  const colName = params?.column?.getColId();
  if (typeof params.value === 'object') {
    if (params?.value?.domain) {
      return decodeValue(params.value.domain);
    }
    if (colName === 'cannibalizations')
      return params.value.length > 0 ? 'true' : 'false';
    if (params?.value?.domain) {
      return decodeValue(params.value.domain);
    }
  }
  if (typeof params.value === 'boolean') {
    if (colName === 'have_cannibal') return params.value ? 'true' : 'false';
  } else if (
    typeof params.value === 'string' ||
    typeof params.value === 'number'
  ) {
    let res = '';
    const decodedValue = decodeValue(params.value);
    if (isHTMLString(decodedValue)) {
      res = removeHTMLTags(decodedValue);
    } else {
      res = decodedValue;
    }
    return res;
  }
  // else if ()
};
const speedExportModify = <TData extends object>(
  params: AgGridCellParams<TData>
): string | undefined => {
  if (typeof params.value === 'object') {
    if (params.value.nodeLabel || params.value?.snippet) {
      return `${params.value.nodeLabel || ''} : ${params.value.snippet || ''}`;
    } else if (params.value.url) {
      return `${decodeValue(params.value.url)}`;
    } else if (params.value.value) {
      // تکرار پایینی بر اساس value.value
      if (typeof params.value.value === 'boolean') {
        return params.value.value ? 'true' : 'false';
      } else if (
        typeof params.value.value === 'string' ||
        typeof params.value.value === 'number'
      ) {
        let res = '';
        const decodedValue = decodeValue(params.value.value);
        if (isHTMLString(decodedValue)) {
          res = removeHTMLTags(decodedValue);
        } else {
          res = decodedValue;
        }
        return res;
      }
    }
  }
  // ازینجا بالا تکرار شده با value.value
  if (typeof params.value === 'boolean') {
    return params.value ? 'true' : 'false';
  } else if (
    typeof params.value === 'string' ||
    typeof params.value === 'number'
  ) {
    let res = '';
    const decodedValue = decodeValue(params.value);
    if (isHTMLString(decodedValue)) {
      res = removeHTMLTags(decodedValue);
    } else {
      res = decodedValue;
    }
    return res;
  }
  // else if ()
};
